import React ,{useState}from "react";
import image1 from "../assets/freepik__adjust__38975.png";
import axios from 'axios';
import Swal from 'sweetalert2';




const ContactForm = () => {
 
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '', 
  });
  
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

 
  const handleSubmit = async (e) => { 
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/contact`, formData);
      
      if (res.status === 200) {
        setFormData({ name: '', email: '', phone: '', message: '' });
  
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Email Sent Successfully!',
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Failed to Send Message',
          text: 'Please try again.',
        });
      }
    } catch (err) {
      console.error(err);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Error Occurred',
        text: 'Something went wrong. Please try again later.',
      });
    }
  };
  

  return (
    <div className="contact-area overflow-hidden mt-5">
      <div className="container">
        <div className="row">
          {/* Contact Form */}
          <div className="col-lg-6 contact-form-box">
            <div className="content">
              <div className="heading mb-4">
                <h2>Need Help?</h2>
                <p>Reach out to the world’s most reliable AI Post Automation Tool.</p>
              </div>
              <form className="wpcf7-form" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email*"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-lg-12 mb-3">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="Phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-12 mb-3">
                  <textarea
  name="message"  // ✅ changed from "comments"
  rows="3"
  className="form-control"
  placeholder="Please describe what you need. *"
  value={formData.message}
  onChange={handleChange}
  required
></textarea>

                  </div>
                  <div className="col-lg-12">
                    <button type="submit" className="btn btn-primary" id="submit">
                      Send
                    </button>
                  </div>
                  
                </div>
              </form>
            </div>
          </div>

          {/* Contact Image */}
          <div className="col-lg-6 text-center">
            <img
              className="contact-img img-fluid mt-5"
              src={image1}
              alt="Contact"
            />
          </div>

        
        </div>
      </div>
      <style jsx>{`
        .contact-area .content .heading {
          margin-bottom: 30px;
        }
        .contact-area form input,
        .contact-area form textarea {
          border: none;
          box-shadow: inherit;
          padding: 15px;
          background: #fafafa;
        }
        .form-control {
          display: block;
          width: 100%;
          height: calc(1.5em + 0.75rem + 2px);
          padding: 0.375rem 0.75rem;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.5;
          color: #495057;
          background-color: #fff;
          background-clip: padding-box;
          border: 1px solid #ced4da;
          border-radius: 0.25rem;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
        form input {
          min-height: 60px;
        }
        .contact-area form textarea {
          min-height: 150px;
        }
        .contact-area form button {
          background: #2e3192;
          border: none;
          display: inline-block;
          color: #fff;
          font-weight: 600;
          padding: 15px 40px;
          border-radius: 5px;
          margin-bottom: -20px;
        }
        .contact-img {
          border-radius: 20px;
          height: 500px;
          width: 500px;
          text-align: center;
        }
        .btn.btn-primary {
          color: #fff;
          background-color: #2e3192 !important;
        }
      `}</style>
    </div>
  );
};



export default ContactForm;
